const getHostname = () => {
  const perlasgoThirdPartyAttachedHostname = document
    ?.getElementById("perlasgo-third-party-attached")
    ?.getAttribute("data-hostname");
  let { hostname = "" } = window.location;
  if (!!perlasgoThirdPartyAttachedHostname && !!perlasgoThirdPartyAttachedHostname?.length) {
    hostname = perlasgoThirdPartyAttachedHostname;
  }
  return hostname;
};

export const HOSTNAME = getHostname();
